
import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";

const useMedida = (formikRef) => {
  const medidaSelect = useSelect("medida");
  const [fila, setFila] = useState(null);
  const [medida, setMedida] = useState(0);

  const [medidas, setMedidas] = useState([]);

  useEffect(() => {
    const fetchMedidas = async () => {
      const result = [];
      await db.unidadeMedidas.filter((a) => a.ativo).each((item) => result.push(item));
      setMedidas(result);
    };

    fetchMedidas();
  }, []);


  const optionMedidas = useMemo(() => prepareForOptions(medidas, ['codigo', 'nome'], 'id'), [medidas]);

  function onChangeMedida(e) {
    medidaSelect.upDateValue(e.value);
    medidaSelect.upDateDefaultValue(e || "");
    if (formikRef?.current) {
      formikRef.current.setFieldValue("unidadeMedidaId", e.value);
      setTimeout(() => formikRef.current.setFieldTouched("unidadeMedidaId", true));
    }
    setMedida(e.value);
  }

  function SetSelectMedida(id) {
    if(optionMedidas?.length){
      const medida = optionMedidas.find((o) => o.value === id);
      if (medida){
        onChangeMedida(medida);
      }
      setFila(null);
    }else{
      setFila(id);
    }
  }

  useEffect(() => {
    if (fila && optionMedidas?.length > 0) {
      SetSelectMedida(fila);
    }
  }, [fila, optionMedidas])


  return {
    medidas,
    optionMedidas,
    onChangeMedida,
    SetSelectMedida,
    medida,
    medidaSelect,
    setMedida
  };
}

export default useMedida;